// A jegy OLVASOTTNAK JELÖLÉSE (a lista „új" jelvénye ebből számol) — háttér-mellékhatás, ezért NINCS toast.
//
// OPTIMISTA: a betöltött lista-lapokon a sor `unread`-je azonnal `none` lesz, így a listára visszalépve a jelvény már
// nincs ott — újratöltés (és a vele járó Odin-kérések) nélkül. Hiba esetén nincs visszagörgetés és nincs hibaüzenet:
// a jelvény a következő listatöltéskor visszajön, adat nem vész el.
import { type InfiniteData, useMutation, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { ticketKeys } from '@/features/tickets/api';
import { api } from '@/lib/api';

type ListPage = Awaited<ReturnType<typeof api.tickets.query>>;

export function useMarkTicketRead(): (ticketId: string) => void {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (ticketId: string) => api.ticketMarkRead.mutation({ params: { id: ticketId } }),
    onMutate: (ticketId: string) => {
      queryClient.setQueriesData<InfiniteData<ListPage>>(
        { queryKey: ticketKeys.lists() },
        (data) =>
          data === undefined
            ? data
            : {
                ...data,
                pages: data.pages.map((p) =>
                  p.status === 200
                    ? {
                        ...p,
                        body: {
                          ...p.body,
                          tickets: p.body.tickets.map((tk) =>
                            tk.id === ticketId ? { ...tk, unread: 'none' as const } : tk,
                          ),
                        },
                      }
                    : p,
                ),
              },
      );
    },
  });
  const { mutate } = mutation;
  return useCallback((ticketId: string) => mutate(ticketId), [mutate]);
}
